var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIco1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.6,
    cy: 28.6,
    r: 27.3,
    stroke: "black",
    strokeWidth: 2.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2559 23.9297H21.3235V41.591H16.2559V23.9297ZM18.6601 21.7217H18.6234C16.7889 21.7217 15.5996 20.3716 15.5996 18.6619C15.5996 16.9172 16.8241 15.5938 18.6952 15.5938C20.5648 15.5938 21.7144 16.9139 21.7511 18.6569C21.7511 20.3666 20.5648 21.7217 18.6601 21.7217ZM41.5985 41.5906H35.8522V32.4495C35.8522 30.0572 34.9533 28.4258 32.9767 28.4258C31.4648 28.4258 30.624 29.5262 30.2327 30.5899C30.0859 30.9695 30.1089 31.5005 30.1089 32.0333V41.5906H24.416C24.416 41.5906 24.4894 25.3993 24.416 23.9276H30.1089V26.6994C30.4452 25.4875 32.2643 23.7578 35.1673 23.7578C38.7689 23.7578 41.5985 26.2999 41.5985 31.7686V41.5906Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIco1);
export default __webpack_public_path__ + "static/media/linkedin_ico1.c21639466f5076e116a3ce16d59b89bb.svg";
export { ForwardRef as ReactComponent };